// extracted by mini-css-extract-plugin
module.exports = {"block":"Logo_block__3CEwB","img":"Logo_img__xu-jF","link":"Logo_link__7oaxr","text":"Logo_text__2xr2i"};